import './VerticalColumn.scss';

import { Col, Space } from 'antd';
import React, { PropsWithChildren } from 'react';

export const VerticalColumn: React.FC<PropsWithChildren> = ({ children }) =>
	<Col
		className='vertical-column'
		span={ 12 }>
		<Space
			direction='vertical'
			size={ 8 }>
			{ children }
		</Space>
	</Col>;

